import React from 'react';
import cls from './information.module.scss';
import { Card, Container } from '@material-ui/core';
import HelmetComponent from '../../components/HelmetComponent';
import { useTranslation } from 'react-i18next';
import CompanyRelocation from '../../components/CompanyRelocation';

const Relocation = ({language}) => {
    const { t } = useTranslation();
    return (
        <main className={cls.information_container}>
            <HelmetComponent titlePage={t('helmet.relocation.title',{ lng: language })} description={t('helmet.relocation.description',{ lng: language })} title={t('helmet.relocation.title',{ lng: language })} keywords={t('helmet.relocation.keywords',{ lng: language })} />
            <div style={{ position: 'relative' }}>
                <Container component="main" maxWidth="lg">
                    {/* </Container> */}
                    <Card className={cls.information_block_card}>
                        <CompanyRelocation language={language}/>
                    </Card>
                </Container>
            </div>
        </main>)
};

export default Relocation;